export default __webpack_public_path__ + "static/media/reactlogo.word.7c837586.svg";